// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.partslists_containers {
  overflow: hidden;
  height: 100vh;
}
.partslists_containers .partslist_container {
  width: 100%;
  display: flex;
  overflow: hidden;
}
.partslists_containers .pgm-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 5.4rem;
}
.partslists_containers .sidebar {
  width: 20%;
  background: #dde7f5;
}
.partslists_containers .partslistmain {
  width: 100%;
  background: #ffffff;
  overflow-y: scroll;
  overflow-x: hidden;
  height: 90vh;
}
.partslists_containers .pgm_spacialtext {
  font-family: Nunito;
  font-size: 20px;
  font-weight: 600;
  display: flex;
  gap: 0.2rem;
}
.partslists_containers .pgm_spacialtext-para {
  font-family: Nunito;
  font-size: 20px;
  font-weight: 600;
  color: #407bff;
}
.partslists_containers .dealers_text {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 1.25rem;
  color: #10132e;
}
.partslists_containers .dealers_button {
  background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);
  border-radius: 5px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 1rem;
  color: #ffffff;
  border: none;
  height: 2.5rem;
  cursor: pointer;
  padding: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.partslists_containers .input-wrapper {
  position: relative;
}
.partslists_containers input {
  border: 1px solid gray;
  border-radius: 6px;
  position: relative;
  width: 92%;
  height: 2.3rem;
  margin: 10px;
  line-height: 6ex;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  color: #10132e;
  padding: 0rem 0.5rem;
}
.partslists_containers label {
  position: absolute;
  top: 0.2ex;
  z-index: 1;
  left: 2em;
  background-color: white;
  padding: 0 5px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #0c3688;
}
.partslists_containers .partscatainersorders {
  display: flex;
  margin: 1rem;
  justify-content: space-between;
  width: 96%;
}
.partslists_containers .partslistcatainersorders {
  display: flex;
  gap: 1rem;
}
.partslists_containers .partscatainersorders_s_s {
  display: flex;
}
.partslists_containers .partslist_catainersorders {
  display: flex;
  gap: 1rem;
  margin: 1rem;
  justify-content: space-between;
  width: 96%;
}
.partslists_containers .pgm_spacialtext-para {
  font-family: "Nunito";
  font-size: 20px;
  font-weight: 600;
  color: #407bff;
}
.partslists_containers .tvsparts_text {
  font-family: "Nunito";
  font-size: 12px;
  font-weight: 500;
  display: flex;
  padding: 0rem 1rem;
  align-items: center;
}
.partslists_containers .modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  color: var(--bs-modal-color);
  pointer-events: auto;
  background-color: var(--bs-modal-bg);
  background-clip: padding-box;
  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);
  border-radius: var(--bs-modal-border-radius);
  outline: 0;
  width: 37rem !important;
}
.partslists_containers .AddpartsbulkAddpartsbulk_parts-d {
  background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);
  box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);
  border-radius: 5px;
  border: none;
  border-radius: 5px;
  color: #ffffff;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  padding: 0rem 1.4rem;
  width: 14rem;
  height: 2.4rem;
  gap: 1rem;
}
.partslists_containers .parts_listsscatainersorders {
  display: flex;
  gap: 1rem;
}
.partslists_containers .AddpartsbulkAddpartsbulk_s {
  background: #e4ecf7;
  box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);
  border-radius: 5px;
  padding: 0rem 1.4rem;
  border: none;
  border-radius: 5px;
  color: #0c3688;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
}
.partslists_containers .select-wrapper {
  position: relative;
  display: block;
}
.partslists_containers select {
  border: 1px solid gray;
  border-radius: 6px;
  position: relative;
  margin: 10px;
  line-height: 6ex;
  width: 94%;
  height: 2.5rem;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  color: #10132e;
  padding: 0rem 0.5rem;
}
.partslists_containers ::placeholder {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  color: #10132e;
  padding: 0rem 0.5rem;
}
.partslists_containers .button_search {
  background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);
  box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);
  border-radius: 5px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  display: flex;
  align-items: center;
  color: #ffffff;
  width: 15%;
  height: 2.5rem;
  text-align: center;
  justify-content: center;
  border: none;
  margin: 0.6rem 1rem;
}
.partslists_containers .button_div {
  display: flex;
  justify-content: center;
  align-items: center;
}
.partslists_containers .fangledowndiv {
  display: flex;
  align-items: center;
  gap: 0.2rem;
  background: #0c3688;
  color: white;
}
.partslists_containers .fangledownupdiv {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap !important;
}
.partslists_containers .tabledata {
  display: flex;
  flex-wrap: wrap !important;
  width: 96%;
  margin: 1rem;
}
.partslists_containers .tabletdnum {
  overflow: hidden;
  word-break: break-all;
  text-overflow: ellipsis;
  padding: 22px 5px;
  font-style: normal;
  font-weight: 400;
  font-size: 16.4px;
  text-align: center;
  padding: 14px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #070707;
  border-top: 0.5px solid #999797;
}
.partslists_containers .table {
  border-collapse: collapse;
  width: 100%;
  overflow: hidden;
  word-break: break-all;
  text-overflow: ellipsis;
  background: #ffffff;
  border: 0.5px solid #999797;
}
.partslists_containers .tabletd {
  overflow: hidden;
  word-break: break-all;
  text-overflow: ellipsis;
  text-align: left;
  padding: 22px 5px;
  font-style: normal;
  font-weight: 400;
  font-size: 16.4px;
  text-align: left;
  padding: 14px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #070707;
  border-top: 0.5px solid #999797;
}
.partslists_containers .tabletd_view {
  text-align: left;
  overflow: hidden;
  word-break: break-all;
  text-overflow: ellipsis;
  padding: 22px 5px;
  text-align: left;
  padding: 14px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  text-decoration-line: underline;
  color: #0c3688;
  border-top: 0.5px solid #999797;
  cursor: pointer;
}
.partslists_containers .footer_div {
  margin-top: 1rem;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
}
.partslists_containers .header_border {
  background: #c0c8da;
  height: 2.4rem;
  border: 1px solid #c0c8da;
}
.partslists_containers .header_border > img {
  margin: 0.9rem 1rem;
}
.partslists_containers .header_border > span {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  align-items: center;
  letter-spacing: -0.28px;
  margin: 0.7rem 1rem;
}
.partslists_containers .totaltable_collumn {
  background-color: #e5f0ff;
}
.partslists_containers .totalSpecialtext {
  font-family: Nunito;
  font-size: 14px;
  font-weight: 700;
}
.partslists_containers .downloads_imgdexcel {
  height: 1.2rem;
}
.partslists_containers .dexcel {
  background: #5CA170;
  box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);
  border-radius: 5px;
  border: none;
  border-radius: 5px;
  color: #ffffff;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  padding: 0rem 1.4rem;
  height: 2.4rem;
  width: 14rem;
  gap: 0.6rem;
  display: flex;
  justify-content: center;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/pages/Parts_Lists_dispatch/partslist.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,aAAA;AACF;AAAE;EACE,WAAA;EACA,aAAA;EACA,gBAAA;AAEJ;AAAE;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;AAEJ;AACE;EACE,UAAA;EACA,mBAAA;AACJ;AACE;EACE,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;AACJ;AACE;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,WAAA;AACJ;AACE;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AACJ;AAEE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AAAJ;AAGE;EACE,mEAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AADJ;AAIE;EACE,kBAAA;AAFJ;AAKE;EACE,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;AAHJ;AAME;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAJJ;AAME;EACE,aAAA;EACA,YAAA;EACA,8BAAA;EACA,UAAA;AAJJ;AAME;EACE,aAAA;EACA,SAAA;AAJJ;AAME;EACE,aAAA;AAJJ;AAME;EACE,aAAA;EACA,SAAA;EACA,YAAA;EACA,8BAAA;EACA,UAAA;AAJJ;AAME;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAJJ;AAME;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;AAJJ;AAME;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;EACA,4CAAA;EACA,UAAA;EACA,uBAAA;AAJJ;AAOE;EACE,mEAAA;EACA,8CAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,YAAA;EACA,cAAA;EACA,SAAA;AALJ;AAOE;EACE,aAAA;EACA,SAAA;AALJ;AAOE;EACE,mBAAA;EACA,8CAAA;EACA,kBAAA;EACA,oBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AALJ;AAOE;EACE,kBAAA;EACA,cAAA;AALJ;AAQE;EACE,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;AANJ;AAQE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;AANJ;AASE;EACE,mEAAA;EACA,8CAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,UAAA;EACA,cAAA;EACA,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;AAPJ;AASE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAPJ;AASE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;AAPJ;AASE;EACE,aAAA;EACA,sBAAA;EACA,0BAAA;AAPJ;AASE;EACE,aAAA;EACA,0BAAA;EACA,UAAA;EACA,YAAA;AAPJ;AASE;EACE,gBAAA;EACA,qBAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,+BAAA;AAPJ;AASE;EACE,yBAAA;EACA,WAAA;EACA,gBAAA;EACA,qBAAA;EACA,uBAAA;EACA,mBAAA;EACA,2BAAA;AAPJ;AA6BE;EACE,gBAAA;EACA,qBAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,+BAAA;AA3BJ;AA6BE;EACE,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,+BAAA;EACA,cAAA;EACA,+BAAA;EACA,eAAA;AA3BJ;AA6BE;EACE,gBAAA;EACA,eAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;AA3BJ;AA6BE;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AA3BJ;AA6BE;EACE,mBAAA;AA3BJ;AA6BE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AA3BJ;AA6BE;EACE,yBAAA;AA3BJ;AA6BE;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;AA3BJ;AA6BE;EACE,cAAA;AA3BJ;AA6BE;EACE,mBAAA;EACA,8CAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA3BJ","sourcesContent":[".partslists_containers {\n  overflow: hidden;\n  height: 100vh;\n  .partslist_container {\n    width: 100%;\n    display: flex;\n    overflow: hidden;\n  }\n  .pgm-name{\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 5.4rem;\n   }\n\n  .sidebar {\n    width: 20%;\n    background: #dde7f5;\n  }\n  .partslistmain {\n    width: 100%;\n    background: #ffffff;\n    overflow-y: scroll;\n    overflow-x: hidden;\n    height: 90vh;\n  }\n  .pgm_spacialtext {\n    font-family: Nunito;\n    font-size: 20px;\n    font-weight: 600;\n    display: flex;\n    gap: 0.2rem;\n  }\n  .pgm_spacialtext-para {\n    font-family: Nunito;\n    font-size: 20px;\n    font-weight: 600;\n    color: #407bff;\n  }\n\n  .dealers_text {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 600;\n    font-size: 1.25rem;\n    color: #10132e;\n  }\n\n  .dealers_button {\n    background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);\n    border-radius: 5px;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 1rem;\n    color: #ffffff;\n    border: none;\n    height: 2.5rem;\n    cursor: pointer;\n    padding: 1rem;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .input-wrapper {\n    position: relative;\n  }\n\n  input {\n    border: 1px solid gray;\n    border-radius: 6px;\n    position: relative;\n    width: 92%;\n    height: 2.3rem;\n    margin: 10px;\n    line-height: 6ex;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 600;\n    font-size: 16px;\n    color: #10132e;\n    padding: 0rem 0.5rem;\n  }\n\n  label {\n    position: absolute;\n    top: 0.2ex;\n    z-index: 1;\n    left: 2em;\n    background-color: white;\n    padding: 0 5px;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    color: #0c3688;\n  }\n  .partscatainersorders {\n    display: flex;\n    margin: 1rem;\n    justify-content: space-between;\n    width: 96%;\n  }\n  .partslistcatainersorders {\n    display: flex;\n    gap: 1rem;\n  }\n  .partscatainersorders_s_s {\n    display: flex;\n  }\n  .partslist_catainersorders {\n    display: flex;\n    gap: 1rem;\n    margin: 1rem;\n    justify-content: space-between;\n    width: 96%;\n  }\n  .pgm_spacialtext-para {\n    font-family: \"Nunito\";\n    font-size: 20px;\n    font-weight: 600;\n    color: #407bff;\n  }\n  .tvsparts_text {\n    font-family: \"Nunito\";\n    font-size: 12px;\n    font-weight: 500;\n    display: flex;\n    padding: 0rem 1rem;\n    align-items: center;\n  }\n  .modal-content {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    color: var(--bs-modal-color);\n    pointer-events: auto;\n    background-color: var(--bs-modal-bg);\n    background-clip: padding-box;\n    border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);\n    border-radius: var(--bs-modal-border-radius);\n    outline: 0;\n    width: 37rem !important;\n  }\n\n  .AddpartsbulkAddpartsbulk_parts-d {\n    background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);\n    box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);\n    border-radius: 5px;\n    border: none;\n    border-radius: 5px;\n    color: #ffffff;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 16px;\n    padding: 0rem 1.4rem;\n    width: 14rem;\n    height: 2.4rem;\n    gap: 1rem;\n  }\n  .parts_listsscatainersorders {\n    display: flex;\n    gap: 1rem;\n  }\n  .AddpartsbulkAddpartsbulk_s {\n    background: #e4ecf7;\n    box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);\n    border-radius: 5px;\n    padding: 0rem 1.4rem;\n    border: none;\n    border-radius: 5px;\n    color: #0c3688;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 16px;\n  }\n  .select-wrapper {\n    position: relative;\n    display: block;\n  }\n\n  select {\n    border: 1px solid gray;\n    border-radius: 6px;\n    position: relative;\n    margin: 10px;\n    line-height: 6ex;\n    width: 94%;\n    height: 2.5rem;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 600;\n    font-size: 16px;\n    color: #10132e;\n    padding: 0rem 0.5rem;\n  }\n  ::placeholder {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 600;\n    font-size: 16px;\n    color: #10132e;\n    padding: 0rem 0.5rem;\n  }\n\n  .button_search {\n    background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);\n    box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);\n    border-radius: 5px;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 16px;\n    display: flex;\n    align-items: center;\n    color: #ffffff;\n    width: 15%;\n    height: 2.5rem;\n    text-align: center;\n    justify-content: center;\n    border: none;\n    margin: 0.6rem 1rem;\n  }\n  .button_div {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  .fangledowndiv{\n    display: flex;\n    align-items: center;\n    gap: 0.2rem;\n    background: #0c3688;\n    color: white;\n  }\n  .fangledownupdiv{\n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap !important;\n  }\n  .tabledata {\n    display: flex;\n    flex-wrap: wrap !important;\n    width: 96%;\n    margin: 1rem;\n  }\n  .tabletdnum {\n    overflow: hidden;\n    word-break: break-all;\n    text-overflow: ellipsis;\n    padding: 22px 5px;\n    font-style: normal;\n    font-weight: 400;\n    font-size: 16.4px;\n    text-align: center;\n    padding: 14px;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    color: #070707;\n    border-top: 0.5px solid #999797;\n  }\n  .table {\n    border-collapse: collapse;\n    width: 100%;\n    overflow: hidden;\n    word-break: break-all;\n    text-overflow: ellipsis;\n    background: #ffffff;\n    border: 0.5px solid #999797;\n  }\n  // .tablesth {\n  //   overflow: hidden;\n  //   word-break: break-all;\n  //   text-overflow: ellipsis;\n  //   color: white;\n  //   text-align: left;\n  //   padding: 14px 12px;\n  //   background-color: #f5f5f5;\n  //   font-style: normal;\n  //   font-weight: 700;\n  //   font-size: 16px;\n  //   background: #0c3688;\n  //   box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);\n  //   border-radius: 5px -2px 0px 0px;\n  //   font-family: \"Nunito\";\n  //   font-style: normal;\n  //   font-weight: 700;\n  //   font-size: 16px;\n  //   color: #ffffff;\n  // }\n  .tabletd {\n    overflow: hidden;\n    word-break: break-all;\n    text-overflow: ellipsis;\n    text-align: left;\n    padding: 22px 5px;\n    font-style: normal;\n    font-weight: 400;\n    font-size: 16.4px;\n    text-align: left;\n    padding: 14px;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    color: #070707;\n    border-top: 0.5px solid #999797;\n  }\n  .tabletd_view {\n    text-align: left;\n    overflow: hidden;\n    word-break: break-all;\n    text-overflow: ellipsis;\n    padding: 22px 5px;\n    text-align: left;\n    padding: 14px;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 14px;\n    text-decoration-line: underline;\n    color: #0c3688;\n    border-top: 0.5px solid #999797;\n    cursor: pointer;\n  }\n  .footer_div {\n    margin-top: 1rem;\n    position: fixed;\n    left: 0;\n    bottom: 0;\n    width: 100%;\n  }\n  .header_border {\n    background: #c0c8da;\n    height: 2.4rem;\n    border: 1px solid #c0c8da;\n  }\n  .header_border > img {\n    margin: 0.9rem 1rem;\n  }\n  .header_border > span {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 16px;\n    display: flex;\n    align-items: center;\n    letter-spacing: -0.28px;\n    margin: 0.7rem 1rem;\n  }\n  .totaltable_collumn {\n    background-color: #e5f0ff;\n  }\n  .totalSpecialtext {\n    font-family: Nunito;\n    font-size: 14px;\n    font-weight: 700;\n  }\n  .downloads_imgdexcel{\n    height: 1.2rem;\n  }\n  .dexcel{\n    background: #5CA170;\n    box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);\n    border-radius: 5px;\n    border: none;\n    border-radius: 5px;\n    color: #ffffff;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 16px;\n    padding: 0rem 1.4rem;\n    height: 2.4rem;\n    width: 14rem;\n    gap: 0.6rem;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n}\n\n// @media screen and (max-width: 780px) {\n//   .pgmlistmain {\n//     width: 100%;\n//     height: 100vh;\n//     background: #ffffff;\n//   }\n//   .pgmlist_container {\n//     width: 100%;\n//     display: flex;\n//     flex-direction: column;\n//   }\n// }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
